var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7062 12.5C40.4062 12.5 12.5 40.5375 12.5 75C12.5 109.463 40.5375 137.5 75 137.5C109.463 137.5 137.5 109.463 137.5 75C137.5 40.5375 109.331 12.5 74.7062 12.5ZM75 125C47.4313 125 25 102.569 25 75C25 47.4313 47.2938 25 74.7062 25C102.444 25 125 47.4313 125 75C125 102.569 102.569 125 75 125Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 43.75H81.25V87.5H68.75V43.75ZM68.75 93.75H81.25V106.25H68.75V93.75Z",
    fill: "#FFCC00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pendingIcon.6ab140698c7b717aa3b85efc6376b2ad.svg";
export { ForwardRef as ReactComponent };